var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.businessName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }